// import axios from "axios";
import AppRoutes from "./route";
import React, { useEffect } from "react";
import AppNotification from "./helpers/AppNotification";
import DeviceModel from "./models/DeviceModel";
import AppCookie from "./helpers/AppCookie";
import AuthMoldel from "./models/AuthMoldel";
// import HomeModel from "./models/HomeModel";
import Swal from 'sweetalert2';
import './theme-override.css';
import './pages/bank-modern.css';

function App() {
//   const [isBlocked, setIsBlocked] = useState(false);
//     const [loading, setLoading] = useState(true);

    useEffect(() => {
        // const checkIP = async () => {
        //     HomeModel.checkIP().then(res => {
        //         if (res.isBlocked === true) setIsBlocked(true);
        //         setLoading(false);
        //     }).catch(err => {
        //         console.log(err);
        //         setLoading(false);
        //     })
        // };
        // if (process.env.REACT_APP_ENV === "production") checkIP();

        const intervalId = setInterval(() => {
            var isLoggedin = AuthMoldel.checkAuth();
            if (isLoggedin) {
                // lấy thông tin máy và trình duyệt

                DeviceModel.getDevice()
                    .then(res => {
                        if (res.success === false) {
                            AuthMoldel.logout().then((res) => {
                                AppCookie.deleteCookie('token');
                                AppCookie.deleteCookie('user');
                                window.location.href = '/login';
                            }).catch((err) => {
                                console.log(err);
                            });

                            Swal.fire({
                                icon: "error",
                                title: "Tài Khoản đã đăng nhập trên thiết bị khác",
                                showConfirmButton: false,
                                timer: 5000,
                            });
                            clearInterval(intervalId);
                        }
                    }).catch(err => {
                    console.log(err);
                    AppNotification.showError('Lấy dữ liệu thất bại!');
                })
            }
        }, 5000);

        return () => clearInterval(intervalId);
    }, []);

    // if (isBlocked) {
    //     window.location.href = "/block.html";
    //     return null;
    // };

    return <AppRoutes />;
}

export default App;
